<div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
        <center>
            <mat-spinner [diameter]="50" [strokeWidth]="4"></mat-spinner>
        </center>
        <p>Veuillez patienter, publication en cours...</p>
    </div>
</div>

<mat-card class="mat-dialog-container">
    <mat-card-header>
        <mat-card-title>Créer une publication</mat-card-title>
        <button mat-icon-button class="close-button mobile-only" (click)="closeBottomSheet()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-header>

    <div class="post-content">
        <textarea #commentInput 
                 placeholder="Écrivez votre texte ici..." 
                 (input)="onInputChange()"
                 class="post-textarea"></textarea>

        <mat-card-content>
            <!-- Aperçu des médias -->
            <div class="media-previews">
                <!-- Aperçu de l'image -->
                <div class="image-preview-container">
                    <ng-container *ngIf="selectedImageFiles.length > 0">
                        <div class="image-item" *ngFor="let image of selectedImageFiles; let i = index">
                            <img [src]="imagePreviewUrls[i]" alt="Aperçu de l'image" />
                            <button mat-icon-button class="remove-media" (click)="removeImage(i)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                        <div *ngIf="selectedImageFiles.length < 3" 
                             class="image-item add-button"
                             (click)="selectFile('image')"
                             [class.disabled]="selectedVideoFile || audioBlobUrl">
                            <mat-icon>add_photo_alternate</mat-icon>
                            <span>Ajouter</span>
                        </div>
                    </ng-container>
                </div>

                <!-- Aperçu de la vidéo -->
                <div class="video-container" *ngIf="selectedVideoFile">
                    <video controls style="width: 100%; height: auto;" [src]="videoPreviewUrl">
                        Votre navigateur ne supporte pas la lecture de vidéos.
                    </video>
                    <button mat-icon-button class="remove-media" (click)="removeVideo()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>

                <!-- Aperçu de l'audio -->
                <div *ngIf="audioBlobUrl" class="media-preview audio-container">
                    <div class="audio-content">
                        <div class="audio-info">
                            <mat-icon class="audio-icon">audiotrack</mat-icon>
                            <span class="audio-label">{{ isRecordedAudio ? 'Enregistrement audio' : 'Fichier audio' }}</span>
                        </div>
                        <audio [src]="audioBlobUrl" controls class="audio-preview" #audioPlayer></audio>
                        <div class="audio-duration" *ngIf="audioDuration">
                            Durée: {{ formatTime(audioDuration) }}
                        </div>
                    </div>
                    <button mat-icon-button class="remove-media" (click)="removeAudio()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Timer pour l'enregistrement audio -->
            <div *ngIf="isRecording" class="timer">
                {{ formatTime(recordingTime) }}
            </div>
        </mat-card-content>

        <div class="post-actions">
            <div class="media-actions">
                <button mat-icon-button class="attach-button" (click)="toggleFileOptions()">
                    <mat-icon>add_circle_outline</mat-icon>
                </button>

                <button mat-icon-button class="camera-button" (click)="openCamera()">
                    <mat-icon>photo_camera</mat-icon>
                </button>

                <button mat-icon-button 
                        class="record-button"
                        [class.recording]="isRecording"
                        (click)="startRecording()" 
                        [disabled]="isRecording || recordingInProgress || selectedImageFiles.length === 0">
                    <mat-icon>mic</mat-icon>
                </button>

                <button mat-icon-button 
                        color="warn" 
                        (click)="stopRecording()" 
                        [disabled]="!isRecording">
                    <mat-icon>stop</mat-icon>
                </button>

                <!-- Options de fichiers -->
                <div *ngIf="fileOptionsVisible" class="file-options">
                    <button mat-button (click)="selectFile('image')" class="file-option">
                        <mat-icon>photo</mat-icon>
                        <span>Photo</span>
                    </button>
                    <button mat-button (click)="selectFile('video')" [disabled]="selectedImageFiles.length > 0" class="file-option">
                        <mat-icon>movie</mat-icon>
                        <span>Vidéo</span>
                    </button>
                    <button mat-button (click)="selectFile('audio')" [disabled]="selectedImageFiles.length === 0" class="file-option">
                        <mat-icon>music_note</mat-icon>
                        <span>Audio</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="post-actions">
            <button mat-raised-button 
                    class="publish-button" 
                    (click)="onPostClick()"
                   >
                <span>Publier</span>
                <mat-icon>send</mat-icon>
            </button>
        </div>

        
    </div>
</mat-card>

<!-- Interface de capture photo -->
<ng-container *ngIf="isCameraActive">
    <div class="camera-interface">
        <div class="camera-preview">
            <video #videoElement autoplay playsinline></video>
            <canvas #canvasElement style="display: none;"></canvas>
        </div>
        <div class="camera-controls">
            <button mat-icon-button class="cancel-button" (click)="closeCamera()">
                <mat-icon>close</mat-icon>
            </button>
            <button mat-fab class="capture-button" (click)="capturePhoto()">
                <mat-icon>camera</mat-icon>
            </button>
            <button mat-icon-button class="cancel-button" (click)="switchCamera()" *ngIf="hasMultipleCameras">
                <mat-icon>flip_camera_ios</mat-icon>
            </button>
        </div>
    </div>
</ng-container>